import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { IconsProviderModule } from './icons-provider.module';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { en_US } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { FormsModule } from '@angular/forms';
// Eager, not provideAnimationsAsync(): ng-zorro's nz-submenu collapses itself purely through
// the collapseMotion animation state (height: 0), with no CSS fallback. While the async
// provider is still fetching the animation engine, that style is not applied and every
// submenu in the sidebar renders at full height — the menu flashes fully expanded on load
// and only snaps shut once the engine arrives.
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient } from '@angular/common/http';
import { SharedModule } from './shared/shared.module';
import { InitModule } from './core/init/init.module';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzResizableModule } from 'ng-zorro-antd/resizable';
import { ViewModule } from './shared/view/view.module';

registerLocaleData(en);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    IconsProviderModule,
    NzLayoutModule,
    NzMenuModule,
    FormsModule,
    SharedModule,
    InitModule,
    NzBreadCrumbModule,
    NzResizableModule,
    ViewModule,
  ],
  providers: [{ provide: NZ_I18N, useValue: en_US }, provideAnimations(), provideHttpClient()],
  bootstrap: [AppComponent],
})
export class AppModule {}
